import { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Header from './components/Header/Header';
import Footer from './components/Footer/Footer';
import Home from './pages/Home';
import Standings from './pages/Standings';
import Matches from './pages/Matches';
import Scorers from './pages/Scorers';
import CompetitionDetails from './pages/CompetitionDetails';
import './App.scss';

function App() {
  
  return (
    <Router>
      <div className="app-container d-flex flex-column min-vh-100">
        <Header />
        <main className="flex-grow-1 py-4">
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/standings" element={<Standings />} />
            <Route path="/matches" element={<Matches />} />
            <Route path="/scorers" element={<Scorers />} />
            <Route path="/competition-details" element={<CompetitionDetails />} />
          </Routes>
        </main>
        <Footer />
      </div>
    </Router>
  );
}

export default App;